var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralFeatureSaveOff = function SvgGeneralFeatureSaveOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    fillRule: "evenodd",
    d: "M16.41 21.836 12 17.164 7.607 21.82c-.672.672-1.61.858-2.468.503a2.21 2.21 0 0 1-1.389-2.079V1.5h16.5v18.744c0 .928-.532 1.724-1.389 2.079a2.218 2.218 0 0 1-2.452-.488",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralFeatureSaveOff;